import React, { FC } from 'react'
import { Box } from '@chakra-ui/core'
import {
  DetailRowWithCounter,
} from '@engyalo/storefront-components'
import { IProductLevel3 } from '@engyalo/storefront-types/lib/plugins/model'
import { ILevel3Props } from './types'

export const CounterCustomization: FC<ILevel3Props> = ({
  data, customizationSelected, setCustomizationSelected, deleteCustomizationSelected, currency
}: ILevel3Props) => {

  if (data) {
    const {
      id,
      name,
      price,
    } = data

    const getValue = (elementId: string | null): number => {
      if (elementId) {
        const value = customizationSelected[elementId]
        if (value && value.quantity) {
          return value.quantity
        }
      }
      return 0
    }

    const addValue = (): void => {
      setCustomizationSelected({
        ...data,
        quantity: (getValue(id) + 1)
      } as IProductLevel3)
    }

    const substractValue = (): void => {
      if ((getValue(id) - 1) === 0) {
        if (deleteCustomizationSelected) {
          deleteCustomizationSelected({
            ...data,
            quantity: (getValue(id) - 1)
          } as IProductLevel3)
        }
      } else {
        setCustomizationSelected({
          ...data,
          quantity: (getValue(id) - 1)
        } as IProductLevel3, false, true)
      }
    }

    let priceText = undefined
    if (price && price > 0) {
      priceText = `+ ${currency} ${price.toFixed(2)}`
    }

    return (
      <Box>
        {
          (id && name) && (
            <DetailRowWithCounter
              key={id}
              title={name}
              subTitle={priceText}
              addAction={addValue}
              minusAction={substractValue}
              value={getValue(id)}
            />
          )
        }
      </Box>
    )
  }

  return null
}
